import 'rxjs/Rx';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
@Injectable()
export class AccSupportPlanService {
    requestStatusCode: any;
    constructor(private http: HttpClient) { }
    getRequest(data) {
        return this.http.get(`/api/internalRequest/getRequest`, {
            params: {
                type: data.requestId,
            }, responseType: 'json', observe: 'response'
        });
    }

    getPlan() {
        return this.http.get('/api/InternalPlan/plans?verbose=true', { responseType: 'json', observe: 'response' });
    }

    getActivePlans() {
        return this.http.get('/api/InternalPlan/plans?status=A', { responseType: 'json', observe: 'response' });
    }

    getPlanById(planId) {
        return this.http.get(`/api/InternalPlan/plans/${planId}`, { responseType: 'json' });
    }

    postPersonPlan(data) {
        return this.http.post(`/api/InternalPersonPlan/createPersonPlan`, data, { observe: 'response' });
    }

    updateRequest(data) {
        return this.http.put(`/api/InternalRequest/updateRequestForPlan`, data, { observe: 'response' });
    }

    getPersonPlan(personId) {
        return this.http.get(`/api/InternalPersonPlan/getPersonPlan`, { params: { "PERSON_ID": personId }, responseType: 'json', observe: 'response' });
    }

    getPersonPlanById(personId) {
        return this.http.get(`/api/InternalPersonPlan/getPersonPlanById`, { params: { "PERSON_ID": personId }, responseType: 'json', observe: 'response' });
    }

    /**
     * @description Updates an existing person_plan if there was a change on screen.
     * @param data 
     */
    updatePersonPlan(data) {
        return this.http.put(`/api/InternalPersonPlan/updatePersonPlan`, data, { observe: 'response' });
    }
    deletePlan(data) {
        return this.http.delete(`/api/InternalPersonPlan/deletePersonPlanById`, { params: { "PERSON_ID": data.PERSON_ID, "PLAN_ID": data.PLAN_ID }, responseType: 'json', observe: 'response' });
    }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/service/accsupportplan.service.ts